import {Component} from "@angular/core";
import {CdkDragHandle, CdkDragPlaceholder} from "@angular/cdk/drag-drop";
import {MatIcon} from "@angular/material/icon";


@Component({
    selector: "drag-item",
    templateUrl: "./drag-item.component.html",
    styleUrls: ["./drag-item.component.css"],
    standalone: true,
    imports: [
        CdkDragHandle,
        MatIcon,
        CdkDragPlaceholder,
    ],
})
export class DragItemComponent {
}
